import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';

const VPSList = ({ onVPSSelect, onCreateNew }) => {
  const [vpsList, setVpsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  });

  useEffect(() => {
    fetchVPSs();
  }, [pagination.page, searchTerm]);

  const fetchVPSs = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await apiRequest(
        `/admin/vps?page=${pagination.page}&limit=${pagination.limit}${searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ''}`
      );
      if (data && data.success) {
        setVpsList(data.data || []);
        setPagination(prev => ({
          ...prev,
          total: data.pagination?.total || 0,
          pages: data.pagination?.pages || 0,
        }));
      } else {
        setError(data.message || 'حدث خطأ في جلب خوادم VPS');
      }
    } catch (error) {
      setError('حدث خطأ في الاتصال بالخادم');
      console.error('Error fetching VPSs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  if (loading && vpsList.length === 0) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        جاري التحميل...
      </div>
    );
  }

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">خوادم VPS</h2>
          <div className="flex gap-2" style={{ alignItems: 'center' }}>
            <input
              type="text"
              placeholder="بحث (IP أو Provider)..."
              value={searchTerm}
              onChange={handleSearch}
              className="form-control"
              style={{ width: '250px' }}
            />
            <button className="btn btn-success btn-sm" onClick={onCreateNew}>
              ➕ إضافة VPS جديد
            </button>
          </div>
        </div>

        {error && (
          <div className="alert alert-danger">
            <span>❌</span>
            <span>{error}</span>
          </div>
        )}

        {vpsList.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🖥️</div>
            <div className="empty-state-title">لا توجد خوادم VPS</div>
            <div className="empty-state-text">ابدأ بإضافة خادم VPS جديد</div>
          </div>
        ) : (
          <>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>IP</th>
                    <th>User</th>
                    <th>Provider</th>
                    <th>عدد العملاء</th>
                    <th>تاريخ البدء</th>
                    <th>تاريخ الانتهاء</th>
                    <th>الحالة</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {vpsList.map((vps) => (
                    <tr key={vps._id}>
                      <td><strong>{vps.ip}</strong></td>
                      <td>{vps.user}</td>
                      <td>{vps.provider || '—'}</td>
                      <td>
                        <span className="badge badge-info">{vps.customerCount || 0}</span>
                      </td>
                      <td>
                        {vps.startDate
                          ? new Date(vps.startDate).toLocaleDateString('ar-SA')
                          : '—'}
                      </td>
                      <td>
                        {vps.endDate
                          ? new Date(vps.endDate).toLocaleDateString('ar-SA')
                          : '—'}
                      </td>
                      <td>
                        <span className={`badge ${vps.isActive ? 'badge-success' : 'badge-danger'}`}>
                          {vps.isActive ? 'نشط' : 'غير نشط'}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => onVPSSelect(vps)}
                        >
                          التفاصيل
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {pagination.pages > 1 && (
              <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => handlePageChange(pagination.page - 1)}
                  disabled={pagination.page === 1}
                >
                  السابق
                </button>
                <span style={{ padding: '0.5rem 1rem', color: 'var(--gray-600)', fontSize: '0.875rem' }}>
                  صفحة {pagination.page} من {pagination.pages}
                </span>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => handlePageChange(pagination.page + 1)}
                  disabled={pagination.page >= pagination.pages}
                >
                  التالي
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default VPSList;
